<template>
    <div class="titles">
        <div class="en">{{enTitle}}</div>
        <div class="zh">{{chTitle}}</div>
    </div>
</template>

<script>
    export default {
        name: "IntroductionTitle",
        props:['enTitle','chTitle'],
        data(){
            return{

            }
        },
    }
</script>

<style scoped>

    .titles{
        text-align: center;
        height: 100px;
        background: #ffffff;
    }
    .titles .en{
        font-size: 50px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
        color: rgba(54, 58, 68, 0.08);
        line-height: 66px;
    }
    .titles .zh{
        font-size: 30px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
        color: #363A44;
        line-height: 40px;
        letter-spacing: 1px;
        margin-top: -35px;
    }
</style>